export default __webpack_public_path__ + "static/media/siili.c7a28a2a.svg";